import { useState } from 'react';
import { useRouter } from 'next/router';
import { useUser } from '@poplar/hooks/useUser';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { AsyncModal } from '@yoweb/ui/components/Modal/AsyncModal';
import { useTranslation } from '@yoweb/next-i18next';
import { MODAL_STANDARD_MAX_WIDTH } from '@poplar/constants/modals';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { QUERY_ENABLE_SESSION_EXPIRATION } from '@poplar/constants/queryParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AuthGuard = function AuthGuard(_ref) {
  var authType = _ref.authType,
      optionalUser = _ref.optionalUser;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated,
      forcedExpiration = _useUser.forcedExpiration;

  var _useState = useState(false),
      isReloading = _useState[0],
      setIsReloading = _useState[1];

  var router = useRouter();

  var _useExternalConfig = useExternalConfig(),
      env = _useExternalConfig.env; // This query parameter allows us to test the session expiration modal in cypress - where it's normally disabled


  var enabledByQueryParam = typeof router.query[QUERY_ENABLE_SESSION_EXPIRATION] === 'string' && router.query[QUERY_ENABLE_SESSION_EXPIRATION] === 'true';
  var disabled = !enabledByQueryParam || env !== 'test';

  if (!authType || authType === 'embed' || disabled) {
    return null;
  }

  if (optionalUser && !forcedExpiration) {
    return null;
  }

  var sessionExpired = !isAuthenticated && authType === 'auth0' || forcedExpiration;
  return /*#__PURE__*/_jsxs(AsyncModal, {
    title: t('session-expired-title'),
    isOpen: sessionExpired,
    hasCloseButton: false,
    shouldCloseOnEsc: false,
    testId: "session-expired-modal",
    maxWidth: MODAL_STANDARD_MAX_WIDTH,
    children: [t('session-expired-text'), /*#__PURE__*/_jsx(Box, {
      display: "flex",
      flexDirection: {
        _: 'column',
        md: 'row'
      },
      mt: {
        _: 'normal3'
      },
      justifyContent: {
        _: 'flex-end'
      },
      children: /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          setIsReloading(true);
          router.reload();
        },
        isLoading: isReloading,
        "data-testid": "session-expired-button",
        size: "lg",
        children: t('session-expired-button')
      })
    })]
  });
};

export default AuthGuard;